import React, { useEffect, useState } from 'react'
import { useHistory, useLocation, useParams } from 'react-router-dom'
import Container from '../../../../components/Container'
import { useLoading } from '../../../../hooks/loading'
import api from '../../../../services/api'
import { FormGroups } from '../components/Form'
import { apiList } from '../domain/api'
import { nameActions } from '../domain/info'
import { breadcrumbUpdate } from '../domain/breadcrumb'
import { toolsUpdate } from '../domain/tools'
import { useToast } from '../../../../hooks/toast'

type Table = {
  id: number
  table_id: number
  wholesale_price: string
  unit_price: string
}
const Update = (): JSX.Element => {
  const { addToast } = useToast()
  const location = useLocation()
  const history = useHistory()
  const { id } = useParams<{ id: string }>()
  const { activeLoading, disableLoading } = useLoading()
  const [familyItem, setFamilyItem] = useState<{
    id: string
    parent_id?: number
    user_id?: number
    name: string
    description?: string
    ncm?: number
    cst?: number
    cfop?: number
    unit_type_id?: number
    price?: string
    spherical_start?: number
    spherical_end?: number
    cylindrical_start?: number
    cylindrical_end?: number
    tables: {
      [key: number]: Table
    }
  }>()

  useEffect(() => {
    async function loadData() {
      activeLoading()
      try {
        const response = await api.get(apiList(id))
        const { data } = response
        const tables: {
          [key: number]: { wholesale_price: string; unit_price: string }
        } = {}
        data.tablesPrices.forEach((table: Table) => {
          tables[table.table_id] = { ...table }
        })
        setFamilyItem({ ...data, tables })
        disableLoading()
      } catch (err) {
        const [, baseUrl, path] = location.pathname.split('/')
        disableLoading()
        addToast({
          type: 'error',
          title: 'Error ao carregar o grupo',
          description:
            'Houve um error ao carregar o grupo, tente novamente mais tarde!'
        })
        if (path.includes('update')) {
          history.push(`/${baseUrl}`)
        } else {
          history.push(`/${baseUrl}/${path}`)
        }
      }
    }
    loadData()
  }, [activeLoading, addToast, disableLoading, history, id, location.pathname])
  return (
    <Container
      pageTitle={nameActions.update.name}
      breadcrumb={breadcrumbUpdate}
      tools={toolsUpdate}
    >
      <FormGroups
        typeForm="update"
        initialValues={{
          idUpdate: Number(familyItem?.id),
          ...familyItem
        }}
      />
    </Container>
  )
}

export default Update
